import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { SideBarMenu } from 'src/app/shared/global/sidebarMenu';
import { UserService } from 'src/app/core/services/user/user.service';
import { AyenServices } from 'src/app/core/services/ayen-services/ayen-services.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  ordersCount;
  sidebarstatus;
  isChild: boolean = false;
  sidebarMenu: any = [];
  showMenu: boolean = false;
  dropdowns: any = {};
  sidebarOpen = false;

  constructor(
    private router: Router,
    private titleService: Title,
    private ayenServices: AyenServices,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
   this.sidebarMenu = SideBarMenu.SIDEBAR_MENU_DATA[this.userService.userType];
   this.dropdowns = SideBarMenu.DROPDOWNS;
   this.activeSideItem();
   this.setupFeatureFlagSubscription();
  }

  setupFeatureFlagSubscription() {
    this.ayenServices.featureFlags$.subscribe({
      next: (data) => {
        if (data) {
          const companyEnabled = this.ayenServices.isFeatureEnabled('USE_COMBINED_COMPANY_USERS_VIEW');

          if (companyEnabled) {
            this.sidebarMenu = this.sidebarMenu.map(item => ({
              ...item,
              isSubMenu: item.sidebarstatus === 'company' ? true : item.isSubMenu
            }));
          }
        }
      }
    });
  }

  checkMenu(name){
    if (this.router.url.includes(name)) {
      return true
    }
  }

  setStatus(status, title, isChild?) {
    this.sidebarstatus = status;
    this.titleService.setTitle(title);
    this.isChild = isChild ? isChild : false;
  }

  toggleSubMenu(name) {
    this.dropdowns[name] = !this.dropdowns[name];
  }

  clickItem(status, title, path, hideSubMenu) {
    this.sidebarstatus = status;
    this.titleService.setTitle(title);
    this.router.navigateByUrl(path);
    if (hideSubMenu) {
      Object.keys(this.dropdowns).forEach(item => {
        this.dropdowns[item] = false;
      })
    }
  }
  activeSideItem() {
    this.sidebarMenu.forEach(item => {
      if(item.isSubMenu) {
        item.subMenuItems.forEach(subItem => {
          if(this.router.url === subItem.url) {
            this.dropdowns[item.sidebarstatus] = true;
            this.setStatus(subItem.sidebarstatus, subItem.pageTile, true);
          }
        })
      }
      else {
        if(this.router.url === item.url) {
          this.setStatus(item.sidebarstatus, item.pageTile);
        }
      }
    })
  }

  logout() {
    this.userService.clearAll();
    this.router.navigateByUrl('/auth/login');
  }
}
